module.exports = (__webpack_require__(0))(214);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/FileInfoWidget.js from dll-reference girder_lib
// module id = 8
// module chunks = 0